// extracted by mini-css-extract-plugin
export default {"searchBar":"searchbar_searchBar__z0HQP"};